/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { clipboardButtonOnClick, decklistContains } from "../store/clipboard";
import { useDispatch, useSelector } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import classNames from "classnames";
import styles from "../styles/Card.module.scss";

const ClipboardButton = ({ cardProps, layout, name, names }) => {
  const dispatch = useDispatch();
  const clipboard = useSelector((state) => state.clipboard); // required to trigger renders

  const cardname = ["modal_dfc", "meld", "transform"].includes(layout) ? names[0] : name;
  if (!cardname) {
    return null;
  }

  const decklistContainsCard = dispatch(decklistContains(cardname));

  return (
    <div
      className={classNames(styles.clipboardButton, {
        [styles.checkmark]: decklistContainsCard,
      })}
      onClick={() => dispatch(clipboardButtonOnClick(cardProps))}
    >
      <FontAwesomeIcon
        className={styles.clipboardButtonIcon}
        icon={decklistContainsCard ? "check" : "plus"}
      />
    </div>
  );
};

export default ClipboardButton;
